import { Section } from '@web_opxp/components';
import { ETagType, renderStringToReact, useTranslation } from '@web_opxp/language';
import * as React from 'react';
import './ScientificSection.scss';

const ScientificSection: React.FC = () => {
  const { t } = useTranslation();
  const content = renderStringToReact(t('prereg:Welcome.ScientificSection.ContentHtml'), ETagType.div, 'text-2col');
  return (
    <Section className="scientific-section" title={t('prereg:Welcome.ScientificSection.Title') ?? ''}>
      {content}
    </Section>
  );
};

export default ScientificSection;
